import React, { useState } from "react";
import { Link2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Copies a crawler-friendly link seeded with the target domain to the clipboard,
// with a small confirmation toast (handy on mobile where the inline label is easy to miss).
export const ShareButton = ({ domain, className = "" }) => {
  const [copied, setCopied] = useState(false);
  if (!domain) return null;
  const shareUrl = `${API}/share?url=${encodeURIComponent(domain)}`;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (err) { /* clipboard unavailable, nothing else to try */ }
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  return (
    <>
      <button
        onClick={onCopy}
        className={`inline-flex items-center gap-1.5 text-[13px] font-medium px-3 py-1.5 rounded-lg border hairline text-asphalt bg-white hover:bg-aqua-tint hover:border-aqua transition-colors ${className}`}
        data-testid="share-button"
      >
        {copied ? <Check size={14} color="#3FC1C9" /> : <Link2 size={14} />}
        {copied ? "Link copied" : "Copy link"}
      </button>
      {copied && (
        <div
          className="fixed left-1/2 -translate-x-1/2 bottom-6 z-[100] inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-white text-[13.5px] font-medium shadow-lg toast-pop"
          style={{ background: "#364F6B" }}
          role="status"
          data-testid="copy-toast"
        >
          <Check size={15} color="#2FE1EC" /> Link copied to clipboard
        </div>
      )}
    </>
  );
};
